module.exports = __webpack_public_path__ + "static/media/Fabrika-zabave-web-ad.eb92e84f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrika-zabave/Fabrika-zabave-web-ad.jpg
// module id = 413
// module chunks = 0